export default __webpack_public_path__ + "static/media/loffle_logo.b43f6fb8.svg";